export enum BannerType {
    INFO = 1,
    WARNING = 2,
    CUSTOM = 3,
}
